<template>
	<div>
		<div>
			商品状态：
			<span @click="setProductStatus('all')" :class="{color_them:this.productStatus == 'all'}" class="product_status_select">全部</span>
			<span @click="setProductStatus('1')" :class="{color_them:this.productStatus == '1'}" class="product_status_select">已通过</span>
			<span @click="setProductStatus('2')" :class="{color_them:this.productStatus == '2'}" class="product_status_select">已拒绝</span>
			<span @click="setProductStatus('0')" :class="{color_them:this.productStatus == '0'}" class="product_status_select">审核中</span>
		</div>
		<div class="title">
			<div style="margin-left: 10px;font-weight: bold;margin-top: 10px;">
				<a-icon type="bars" />
				&nbsp;商品列表
			</div>
			<div>
				<span class="search">
					商品名称：<a-input v-model="productName" placeholder="搜索商品名称" />
				</span>
				<span class="search">
					商品分类：
					<a-select style="width: 200px;" v-model="classify" placeholder="搜索商品分类">
						<a-select-option :key="index" v-for="(item, index) in typeList" :value="item.id">{{ item.name }}</a-select-option>
					</a-select>
				</span>
					
				<span class="search">
					商品上下架：
					<a-select
					    labelInValue
						v-model="putAwayKey"
					    style="width: 120px"
					    @change="handleChangePutAway"
					  >
					    <a-select-option value="all">全部</a-select-option>
					    <a-select-option value="1">上架</a-select-option>
						<a-select-option value="0">下架</a-select-option>
					</a-select>
				</span>
				
				<span class="search">
					商品状态：
					<a-select
					    labelInValue
						v-model="statusKey"
					    style="width: 120px"
					    @change="handleChange"
					  >
					    <a-select-option value="all">全部</a-select-option>
					    <a-select-option value="1">已通过</a-select-option>
						<a-select-option value="2">已拒绝</a-select-option>
						<a-select-option value="0">审核中</a-select-option>
					  </a-select>
				</span>
				<span class="search">
					<a-button type="primary" @click="searchHandle" icon="search">搜索</a-button>
					<a-divider type="vertical" />
					<a-button @click="resetHandle" icon="reload">重置</a-button>
				</span>
			</div>
		</div>
		
		
		<a-table
			:columns="columns"
			:pagination="pagination"
			@change="handleTableChange"
			:expandedRowKeys="openRows"
			bordered
			:dataSource="data"
			@expandedRowsChange="expandedRowsChange"
			class="components-table-demo-nested"
		>
			<a slot="operation" slot-scope="text,recode">
			
				<a-button type="link" @click="showDrawer(text.productId)" size="small">编辑</a-button>
				
				<span v-if="recode.putAway == true">
					<a-divider type="vertical" />
					
					<a-popconfirm
						title="将下架该产品,是否下架？"
						@confirm="soldOutProduct(text.productId)"
						@cancel="cancel"
						okText="下架"
						cancelText="取消"
					>
						<a-button  type="link" size="small">下架</a-button>
					
					</a-popconfirm>
				</span>
				
				<span>
					<a-divider type="vertical" />
					
					<a-popconfirm
						title="将删除该商品,是否删除？"
						@confirm="deleteProduct(text.productId)"
						@cancel="cancel"
						okText="删除"
						cancelText="取消"
					>
						<a-button  type="link" size="small">删除</a-button>
					
					</a-popconfirm>
				</span>
			</a>
			<img slot="productPic" style="width: 150px;" slot-scope="text" :src="text.productPic[0]" alt="" />

			<a-tag slot="productSort" slot-scope="text" color="cyan">{{ text.productSort }}</a-tag>
			<span slot="tag" slot-scope="text">
				<div>
					上架：
					<a-switch disabled :defaultChecked="text.putAway" />
				</div>
				<p></p>
				<div>
					推荐：
					<a-switch disabled :defaultChecked="text.recommend" />
				</div>
				<p></p>
				<div>
					支付：
					<a-switch disabled :defaultChecked="text.onlinePay" />
				</div>
			</span>
			<span slot="onLinePay" slot-scope="text">
				<a-tag v-if="text.onLinePay == 1" color="#87d068">
					<a-badge status="success" />
					开启
				</a-tag>
				<a-tag v-if="text.onLinePay == 0" color="#f50">
					<a-badge status="success" />
					关闭
				</a-tag>
			</span>

			<span slot="auditStatus" slot-scope="text">
				<a-tag v-if="text.auditStatus == 1" color="#87d068">
					<a-badge status="success" />
					已通过
				</a-tag>
				<a-tag v-if="text.auditStatus == 0" color="#f50">
					<a-badge status="success" />
					审核中
				</a-tag>
				<a-tag v-if="text.auditStatus == 2" color="#ff0000">
					<a-badge status="success" />
					已拒绝
				</a-tag>
			</span>
			
			<span slot="auditStatusExplain" slot-scope="text">
				<span v-if="text.auditStatusExplain == null || text.auditStatusExplain == '' || text.auditStatusExplain == undefined">
					暂无信息
				</span>
				<span v-else>
					{{text.auditStatusExplain}}
				</span>
			</span>

			<a-table slot="expandedRowRender" slot-scope="text" :columns="innerColumns" :dataSource="text.specificationList" :pagination="false">
				<span slot="specificationPic" slot-scope="text"><img style="width: 80px;" :src="text.specificationPic" alt="" /></span>
			</a-table>
		</a-table>

		<a-drawer  :width="1200" title="编辑商品" placement="right" :closable="false" @close="onClose" :visible="visible" :afterVisibleChange="afterVisibleChange">
			<ModifyCommodity @event1="change($event)" :productId="modifyId" ></ModifyCommodity>
		</a-drawer>
	</div>
</template>

<script>
import api from '../../../api/Api.js';
import ModifyCommodity from './ModifyCommodity.vue'

const columns = [
	{ title: '商品名称', width: '250px', dataIndex: 'productName', key: 'productName' },
	{ title: '商品图片', width: '200px', key: 'productPic', scopedSlots: { customRender: 'productPic' } },
	{ title: '排序', width: '120px', key: 'productSort', scopedSlots: { customRender: 'productSort' } },
	{ title: '标签', width: '200px', key: 'tag', scopedSlots: { customRender: 'tag' } },
	{ title: '添加时间', dataIndex: 'indate', key: 'indate' },
	{ title: '审核状态', key: 'auditStatus', scopedSlots: { customRender: 'auditStatus' } },
	{ title: '审核内容', key: 'auditStatusExplain',scopedSlots: { customRender: 'auditStatusExplain' }},
	{ title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

const innerColumns = [
	{ title: '规格图片', key: 'specificationPic', scopedSlots: { customRender: 'specificationPic' } },
	{ title: '规格', dataIndex: 'specification', key: 'specification' },
	{ title: '库存(件)', dataIndex: 'ku', key: 'ku' },
	{ title: '市场价格(元)', dataIndex: 'bazaarPrice', key: 'bazaarPrice' },
	{ title: '帝全价格(元)', dataIndex: 'price', key: 'price' }
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};

const data = [];

export default {
	components: {
		ModifyCommodity
	},
	data() {
		return {
			rowSelection,
			page: 0,
			data,
			columns,
			innerColumns,
			index: 0,
			openRows: [],
			pagination: { current: 0, pageSize: 5, total: 55 },
			visible: false,
			modifyId:0,
			typeList:[],
			putAwayKey: { key: 'all' },
			putAway:'all',
			productName:'',
			classify:'',
			statusKey : { key: 'all' },
			productStatus: 'all'
		};
	},
	mounted() {
		this.data = [];
		this.commodityListInfo();
		this.getInfoType();
		String.prototype.splice = function(start, newStr) {
			return this.slice(0, start) + newStr + this.slice(start);
		};
	},
	watch : {
		visible:function(val) {
			this.visible = val;
		}
	},
	methods: {
		afterVisibleChange(val) {
			this.commodityListInfo();
			console.log('visible', val);
		},
		showDrawer(modifyId) {
			this.modifyId = modifyId;
			this.visible = true;
		},
		onClose() {
			this.visible = false;
		},
		handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			this.pagination = pagination;
			this.page = this.pagination.current - 1;
			this.data = [];
			this.commodityListInfo();
		},
		expandedRowsChange(expandedRows) {
			this.openRows.shift();
			this.openRows = expandedRows;
		},
		numberToBool(number) {
			if (number == 1) {
				return true;
			} else {
				return false;
			}
		},
		getInfoType() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/typeList';
			let parm = {
				parentId: 0
			};
		
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.typeList = res.data.data;
				} else {
					this.$message.waring(res.data.message);
				}
			});
		},
		commodityListInfo() {
			this.data = [];
			const that = this;
			let url = 'api/store/v1/admin/commodity/commodityList';
			let parm = {
				page: that.page,
				productName: this.productName,
				classify: this.classify,
				productStatus: this.productStatus,
				putAway: this.putAway
			};

			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					console.log(res.data);
					const commodityList = res.data.data;
					that.pagination.total = res.data.maxCount;
					commodityList.forEach((item, index, array) => {
						item.key = index;
						item.putAway = that.numberToBool(item.putAway);
						item.recommend = that.numberToBool(item.recommend);
						item.postage = that.numberToBool(item.postage);
						item.onlinePay = that.numberToBool(item.onlinePay);

						that.data.push(array[index]);
						array[index].specificationList.forEach((item, index, array) => {
							item.key = index;
							item.price = item.price + '';
							item.bazaarPrice = item.bazaarPrice + '';
							var arr = item.price.split('');
							var arr2 = item.bazaarPrice.split('');
							var price = '';
							var bazaarPrice = '';
							for (var i = 0; i < arr.length; i++) {
								price += arr[i];
								if (i == arr.length - 3) {
									price += '.';
								}
							}
							for (var i = 0; i < arr2.length; i++) {
								bazaarPrice += arr2[i];
								if (i == arr2.length - 3) {
									bazaarPrice += '.';
								}
							}
							item.price = price;
							item.bazaarPrice = bazaarPrice;
						});
					});
				} else {
					this.$message.error(res.message);
				}
			});
		},
		resetHandle(){
			this.createTime = undefined;
			this.productName = '';
			this.classify = '';
			this.productStatus = 'all';
			this.statusKey = { key: 'all' };
		},
		deleteProduct(id){
			const that = this;
			let url = 'api/store/v1/admin/commodity/deleteCommodity';
			let parm = {
				id: id
			};
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					this.commodityListInfo();
					this.$message.success("商品删除成功！");
				}
			});
			
		},
		soldOutProduct(id){
			const that = this;
			let url = 'api/store/v1/admin/commodity/soldOutCommodity';
			let parm = {
				id: id
			};
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					this.commodityListInfo();
					this.$message.success("商品下架成功！");
				}
			});
			
		},
		change(data) {
			this.visible = data;
		},
		cancel(){
		},
		handleChange(value) {
			this.productStatus = value.key;
		},
		setProductStatus(value) {
			this.productStatus = value;
			this.commodityListInfo();
		},
		handleChangePutAway(value) {
			this.putAway = value.key;
		},
		searchHandle(){
			this.commodityListInfo();
		},
	}
};


</script>

<style>
.banner-title {
	border-bottom: 2px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
.title {
	border: 2px solid gainsboro;
	margin-bottom: 30px;
	margin-top: 25px;
	border-radius: 5px;
	height: 105px;
}

.search{
	margin-left: 70px;
}
.search input{
	width: 200px;
	margin-top: 10px;
}
.product_status_select{
	margin-left: 25px;
	font-size: 25px;
	cursor:pointer;
}
.color_them{
	color: #108EE9;
}
</style>
